import React, { useEffect, useState, FC } from 'react';

import { ValueFieldProps } from '@sitecore-jss/sitecore-jss-react-forms/types';

import { documentService, windowService } from '../../../../utils/window.utils';

const PageTitleField: FC<ValueFieldProps> = (props) => {
  const { field } = props;
  const hasAnyError = !!props.errors?.length;
  const [value, setValue] = useState(props.value);
  const FieldValidationErrors = props.fieldValidationErrorsComponent;
  const id = field?.valueField?.id;
  const name = field?.valueField?.name;

  useEffect(() => {
    const title = windowService()?.btoa(encodeURIComponent(documentService().title));

    setValue(title);
    props.onChange(field.valueField.name, title, props.isValid, []);
  }, []);

  return (
    <div
      className={`sitecore-jss-form__control sitecore-jss-form__control--text-box ${
        hasAnyError ? 'sitecore-jss-form__control--has-error' : ''
      }`}
    >
      <input id={id} name={name} className="sitecore-jss-form__field" type="hidden" value={value} form="novalidatedform" />
      {FieldValidationErrors && <FieldValidationErrors {...props} />}
    </div>
  );
};

export default PageTitleField;
